import { Message } from 'element-ui';

/* eslint-disable no-param-reassign */
export default {
  namespaced: true,

  state: {
    lastError: null,
    ga: null,
  },

  getters: {},

  mutations: {
    ga(state, payload) {
      state.ga = payload;
    },

    lastError(state, payload) {
      state.lastError = payload;
    },
  },

  actions: {
    error({ commit, state }, payload) {
      commit('lastError', payload.error);

      if (state.ga) {
        if (payload.error) {
          state.ga.exception(
            payload.error.message || payload.error,
          );
        } else {
          state.ga.exception('Unkown error');
        }
      }

      Message({
        showClose: true,
        message:
          payload.message || 'Ops, an error occurred',
        type: 'error',
        duration: 6000,
      });

      return Promise.reject(payload.error);
    },

    successMessage(context, payload) {
      Message({
        showClose: true,
        dangerouslyUseHTMLString: false,
        message: payload,
        type: 'success',
        duration: 3000,
      });
    },

    validationError(context, payload) {
      Message({
        showClose: true,
        dangerouslyUseHTMLString: false,
        message:
          payload.message || 'Ops, an error occurred',
        type: 'error',
        duration: 6000,
      });
    },

    validationErrorHtml(context, payload) {
      Message({
        showClose: true,
        dangerouslyUseHTMLString: true,
        message:
          payload.message || 'Ops, an error occurred',
        type: 'error',
        duration: 6000,
      });
    },
  },
};
